import controller from '../../../controller/controller.js';
import breakpoints from '../../../breakpoints.js';

/**
 * Автооткрытие пользовательской шторки личного кабинета по параметру ?openLkNav=1.
 *
 * Используется после первого сохранения профиля (регистрация): пользователя
 * редиректит на /personal/create/construction/?openLkNav=1, и здесь на мобильном
 * шторка (bottom-sheet) открывается автоматически.
 *
 * Открываем только на мобильном (≤sm) — там шторка выезжает снизу. На десктопе
 * шторка ЛК живёт в левой колонке и «выезжать» ей некуда, поэтому не трогаем.
 */
export const openLkNav = () => {
	const params = new URLSearchParams(window.location.search);
	if (params.get('openLkNav') !== '1') {
		return;
	}

	// убираем параметр из URL, чтобы обновление страницы не открывало шторку снова
	params.delete('openLkNav');
	const cleanQuery = params.toString();
	const cleanUrl = window.location.pathname + (cleanQuery ? '?' + cleanQuery : '') + window.location.hash;
	window.history.replaceState(null, null, cleanUrl);

	if (window.innerWidth > breakpoints['sm-max']) {
		return;
	}

	// Шторка (v-internal-nav) — Vue-компонент, монтируется асинхронно и слушает
	// событие lk-nav-open в created(). Даём кадр на монтирование, затем открываем.
	setTimeout(() => {
		controller.openLkMobileMenu();
	}, 400);
};
